<template>
  <div ref="rootRef">
    <slot></slot>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import useScroll from "./useScroll";

export default defineComponent({
  name: "scroll",
  props: {
    click: {
      type: Boolean,
      default: true
    },
    probeType: {
      type: Number,
      default: 0
    },
    pullUpLoad: {
      type: Boolean,
      default: false
    }
  },
  emits: ["scroll", "isPullingUp"],
  setup(props, { emit }) {
    const rootRef = ref(null);

    const scroll = useScroll(rootRef, props, emit);

    return {
      rootRef,
      scroll
    };
  }
});
</script>

<style></style>
